import _ from 'lodash'
import i18next from 'i18next'
import store from '@/store/index.js'

import { formatDate } from '@/lib/date'

const organization = store.organization.getOrganization()

function getSiteGroupsNames(siteGroupIds, siteGroups) {
  return siteGroups
    .filter(siteGroup => siteGroupIds.includes(siteGroup.id))
    .map(siteGroup => siteGroup.name)
    .join(', ')
}

function getSiteCountryName(siteId, sites) {
  const site = sites.find(site => site.id === siteId)
  return i18next.t(`countries.${site?.countryCodes?.[0]}`)
}

export default {
  id: item => item?.id ?? '',
  contentType: item =>
    organization?.customNamings?.[item.entityType]?.singular ||
    i18next.t(`common.entity_type.${_.snakeCase(item?.entityType)}`),
  title: item => item?.name,
  status: item =>
    i18next.t(`common.status_options.${_.snakeCase(item?.status)}`),
  site: item => item?.site?.name ?? '',
  country: (item, orgStructure) =>
    getSiteCountryName(item.site.id, orgStructure?.sites),
  siteGroups: (item, orgStructure) =>
    getSiteGroupsNames(item.siteGroups, orgStructure.siteGroups),
  tags: item =>
    item?.tags
      ?.map?.(tag => {
        return tag?.name
      })
      .join(', '),
  createdAt: item => formatDate(item?.createdAt),
  completedAt: item => formatDate(item?.completedAt),
  categories: item =>
    item?.categories
      ?.map?.(category => i18next.t(`categories.${category}`))
      .join(', '),
}
